import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

export default function Mentions() {
  return (
    <>
      <Navigation type={0} />

      <main className='main u-padding-large'>
        <h1 className='mentions-title u-center-text'>
          MENTIONS LÉGALES ET POLITIQUE DE CONFIDENTIALITÉ
        </h1>
        <h2 className='mentions-sous-titre u-center-text u-margin-top-medium u-margin-bottom-medium'>
          Mentions légales
        </h2>
        <ol className='u-margin-left'>
          <li className='mentions-liste common-text u-justify-text'>
            Édition du site <br />
            En vertu de l&apos;article 6 de la loi n° 2004-575 du 21 juin 2004 pour la confiance
            dans l&apos;économie numérique, il est précisé aux utilisateurs du site internet
            www.yoga-taranga.fr l&apos;identité des différents intervenants dans le cadre de sa
            réalisation et de son suivi :
            <ul className='u-margin-left'>
              <li>Propriétaire du site : Association loi 1901 : Yoga Taranga</li>
              <li>
                Adresse postale : Maison de la vie associative, Rue des Charmilles, 50 000 Saint-Lô
              </li>
              <li>Directeur de la publication : Antoine Penou</li>
              <li>Hébergeur : OVH </li>
              <li>Délégué à la protection des données : yoga.taranga50@gmail.com</li>
            </ul>
          </li>
          <li className='mentions-liste common-text u-justify-text'>
            Propriété intellectuelle et contrefaçons <br />
            L'association Yoga Taranga est propriétaire des droits de propriété intellectuelle et
            détient les droits d&apos;usage sur tous les éléments accessibles sur le site internet,
            notamment les textes, images, graphismes, logos, vidéos, architecture, icônes et sons.
            <br />
            Toute reproduction, représentation, modification, publication, adaptation de tout ou
            partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est
            interdite, sauf autorisation écrite préalable de Yoga Taranga.
          </li>
          <li className='mentions-liste common-text u-justify-text'>
            Limitations de responsabilité
            <br />
            Yoga Taranga ne pourra être tenue pour responsable des dommages directs et indirects
            causés au matériel de l&apos;utilisateur, lors de l&apos;accès au site
            www.yoga-taranga.fr.
            <br />
            L'association s'engage à sécuriser au mieux le site, cependant sa responsabilité ne
            pourra être mise en cause si des données indésirables sont importées et installées à son
            insu.
          </li>
          <li className='mentions-liste common-text u-justify-text'>
            CNIL et gestion des données personnelles
            <br />
            Conformément aux dispositions de la loi 78-17 du 6 janvier 1978 modifiée,
            l&apos;utilisateur dispose d&apos;un droit d&apos;accès, de modification et de
            suppression des informations collectées. Pour exercer ce droit, envoyez un message à
            notre Délégué à la Protection des Données : yoga.taranga50@gmail.com.
          </li>
          <li className='mentions-liste common-text u-justify-text'>
            {' '}
            Liens hypertextes et cookies <br />
            Le site www.yoga-taranga.fr contient des liens hypertextes vers d&apos;autres sites et
            dégage toute responsabilité quant à ces liens externes. La navigation sur le site peut
            provoquer l&apos;installation de cookies. Vous avez la possibilité d&apos;accepter ou de
            refuser les cookies en modifiant les paramètres de votre navigateur. Aucun cookie ne
            sera déposé sans votre consentement.
          </li>
          <li className='mentions-liste common-text u-justify-text '>
            Droit applicable et attribution de juridiction
            <br />
            Tout litige en relation avec l&apos;utilisation du site est soumis au droit français. En
            dehors des cas où la loi ne le permet pas, il est fait attribution exclusive de
            juridiction aux tribunaux compétents de Saint-Lô.
          </li>
        </ol>
        <h2 className='mentions-sous-titre u-center-text u-margin-top-big u-margin-bottom-medium'>
          Politique de confidentialité
        </h2>
        <ol className='u-margin-left'>
          <li className='mentions-liste common-text u-justify-text'>
            Collecte de l&apos;information
            <br />
            Nous recueillons les informations lorsque vous nous contactez via notre site : nom,
            prénom, adresse e-mail. Nous enregistrons également automatiquement des informations
            comme votre adresse IP.
          </li>
          <li className='mentions-liste common-text u-justify-text'>
            Utilisation des informations
            <br />
            Les informations que nous recueillons peuvent être utilisées pour :
            <ul>
              <li>Améliorer le service client,</li>
              <li>Vous contacter par e-mail si besoin,</li>
              <li>Sécuriser le site.</li>
            </ul>
          </li>
          <li className='mentions-liste common-text u-justify-text'>
            Confidentialité
            <br />
            Vos informations ne seront ni vendues, ni échangées, ni transférées à une autre société
            sans votre consentement.
          </li>
          <li className='mentions-liste common-text u-justify-text'>
            Protection des informations
            <br />
            Nous mettons en place des mesures de sécurité pour protéger vos informations
            personnelles.
          </li>
          <li className='mentions-liste common-text u-justify-text'>
            Se désabonner ou supprimer ses données
            <br />
            Vous pouvez à tout moment demander la suppression de vos données en envoyant un mail à
            yoga.taranga50@gmail.com avec pour objet : "Demande de suppression de mes données
            personnelles".
          </li>
          <li className='mentions-liste common-text u-justify-text'>
            Consentement
            <br />
            En utilisant ce site, vous consentez à notre politique de confidentialité.
          </li>
        </ol>
      </main>
      <Footer />
    </>
  );
}
